import React from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import md5 from 'react-native-md5'
import Spinner from './Spinner'
import 'bootstrap/dist/css/bootstrap.min.css'
//import Loader from 'react-loader-spinner'
//import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css'

const imgStyle = {
  width: '40px',
  height: '40px',
  marginLeft: '30px',
}

const spanStyle = {
  fontWeight: 'bold',
  fontSize: '24px',
}

const butStyle = {
  marginLeft: '15px',
}

class Picture extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props.employee.employee) {
      const empl = this.props.employee.employee
      const gravatarId = md5.hex_md5(empl['email'])
      const l = '/edit_employee/' + empl['id']
      const ld = '/users/' + empl['id'] + '/document'
      const lt = '/users/' + empl['id'] + '/templates'
      return <div><span style={spanStyle}>{empl.name}</span><img src={'https://secure.gravatar.com/avatar/' + gravatarId + '?s=80'} alt={empl.name} className="gravatar" style={imgStyle} /><a href={l} className="btn btn-secondary col-sm-2 offset-sm-2">Edit</a><a href={ld} className="btn btn-secondary col-sm-2" style={butStyle}>Add document</a><a href={lt} className="btn btn-secondary col-sm-2" style={butStyle}>Templates</a></div>
    }
    return <div><Spinner></Spinner></div>
  }
}

Picture.propTypes = {
  employee: PropTypes.object.isRequired,
}

export default Picture
